// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CalendarIntegrationSettingsSchema () {
        return CalendarIntegrationSettingsSchema;
    },
    get CompanyBillingSettingsModel () {
        return CompanyBillingSettingsModel;
    },
    get CompanyLinkModel () {
        return CompanyLinkModel;
    },
    get CompanyModel () {
        return CompanyModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _ai = require("./ai");
const _engagement = require("./engagement");
const _featureflag = require("./feature-flag");
const _stripe = require("./stripe");
const CalendarIntegrationSettingsSchema = _zod.z.object({
    enabled: _zod.z.boolean()
});
const AuthenticationSettingsSchema = _zod.z.object({
    authentication_methods: _zod.z.record(_zod.z.string(), _zod.z.object({
        state: _zod.z.enum([
            "enabled",
            "disabled"
        ])
    })).optional(),
    ip_whitelist_settings: _zod.z.object({
        enforced_state: _zod.z.enum([
            "open",
            "enforce"
        ])
    }).optional()
}).catchall(_zod.z.any());
const CompanyModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    activation_status: _zod.z.string(),
    active_users: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    admins: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    billing_admins: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    billing_expires: _zod.z.date(),
    bor_required: _zod.z.boolean(),
    custom_billing: _zod.z.boolean(),
    custom_branding: _zod.z.boolean(),
    expires: _zod.z.date(),
    functions: _zod.z.record(_zod.z.any()),
    icon_color: _zod.z.string().optional(),
    max_doc_space: _zod.z.number(),
    max_users: _zod.z.number(),
    name: _zod.z.string(),
    nav_color: _zod.z.string().optional(),
    price_per_user: _zod.z.number(),
    review_forms: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    review_workflows: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    stripe_customer_info: _stripe.StripeCustomerModel.optional(),
    workflow_templates: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    settings: _zod.z.record(_zod.z.union([
        _zod.z.boolean(),
        _zod.z.number()
    ])).optional(),
    aggregation_tables: _zod.z.object({
        review_assignments: _zod.z.object({
            last_update: _zod.z.date(),
            building: _zod.z.boolean()
        })
    }).optional(),
    has_tree: _zod.z.boolean().optional(),
    needs_recompute: _zod.z.boolean().optional(),
    computing_tree: _zod.z.boolean().optional(),
    basic_admins: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    implementation_date: _zod.z.date().optional(),
    authentication_settings: AuthenticationSettingsSchema.optional(),
    notifications: _zod.z.record(_zod.z.any()),
    default_timezone: _zod.z.string().optional(),
    job_statuses: _zod.z.object({
        invites_resent: _zod.z.date()
    }).optional(),
    public_api: _zod.z.object({
        created_at: _zod.z.date(),
        usage_plan_id: _zod.z.string(),
        updated_at: _zod.z.date().optional()
    }).optional(),
    engagement: _engagement.EngagementSettingsSchema.optional(),
    ai: _ai.AiSettingsSchema.optional(),
    calendar_integration: CalendarIntegrationSettingsSchema.optional(),
    feature_flag: _zod.z.record(_zod.z.enum(_featureflag.FLAG_SLUGS), _zod.z.string().or(_zod.z.number()).or(_zod.z.boolean())).optional(),
    licenses: _zod.z.array(_zod.z.string()).optional(),
    decimal_places: _zod.z.number().optional(),
    max_doc_spaces: _zod.z.number().optional(),
    next_invoice: _zod.z.object({
        price: _zod.z.number(),
        seats: _zod.z.number(),
        start: _zod.z.date(),
        end: _zod.z.date(),
        unit_price: _zod.z.number(),
        frequency: _zod.z.string(),
        terms: _zod.z.string()
    }).optional(),
    min_users_to_add: _zod.z.number().optional(),
    tax_address: _zod.z.object({
        company_code: _zod.z.string().optional(),
        address_line_1: _zod.z.string().optional(),
        zip: _zod.z.string().optional(),
        address_line_2: _zod.z.string().optional(),
        has_tax_exclusion: _zod.z.boolean().default(false)
    }).optional()
});
const CompanyLinkModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    adder: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    description: _zod.z.string(),
    score: _zod.z.number(),
    title: _zod.z.string(),
    url: _zod.z.string()
});
const CompanyBillingSettingsModel = CompanyModel.pick({
    _id: true,
    name: true,
    billing_admins: true,
    next_invoice: true,
    billing_expires: true,
    price_per_user: true,
    stripe_customer_info: true,
    min_users_to_add: true,
    max_users: true,
    tax_address: true
});
